import URI from 'urijs'
import Vue from 'vue'
import { config } from '@/plugins/env.config'

async function getDoctorInformation (doctor, attemptNumber = 1) {
  const getUri = new URI(config.apiBaseUrl)
  getUri.segment('ehr')
  getUri.segment('v1')
  getUri.segment('doctors')
  getUri.segment(doctor.id)

  try {
    return await Vue.prototype.$http.get(getUri.toString())
  } catch (error) {
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response
    const status = response.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return getDoctorInformation(doctor, attemptNumber + 1)
    }

    throw error
  }
}

async function validateMedicalLicence (doctor, attemptNumber = 1) {
  const getUri = new URI(config.apiBaseUrl)
  getUri.segment('ehr')
  getUri.segment('v1')
  getUri.segment('medical-license-verification')

  const requestConfig = {
    params: {
      email_address: doctor.emailAddress
    }
  }

  try {
    return await Vue.prototype.$http.get(getUri.toString(), requestConfig)
  } catch (error) {
    const maxAttempts = config.getTokenMaxAttempts
    const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

    const response = error.response
    const status = response.status

    if (status === 500 && attemptNumber < maxAttempts) {
      await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
      return getDoctorInformation(doctor.email_address, attemptNumber + 1)
    }

    throw error
  }
}

export {
  getDoctorInformation,
  validateMedicalLicence
}